import unionAxios from "@/utils/union-axios";

/**
 * 获取用户信息
 */
export const previewDetails = (params) => {
  return unionAxios.post(`/web-h5/charge/marketingH5Page/preview`, params);
};

/**
 * 获取页面预览配置
 */
export const previewDetailsV2 = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingH5Page/findPageConfig`,
    params,
  );
};

/**
 * 获取领奖信息
 */
export const getPrize = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingHomepage/batchWelfareByUid`,
    params,
  );
};

/**
 * 领取奖品
 */
export const receivePrize = (params) => {
  return unionAxios.post(`/web-h5/charge/marketingHomepage/claim`, params);
};

export const batchWelfareByUid = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingHomepage/batchWelfareByUid`,
    params,
  );
};

/**
 * 获取活动详情
 */
export const getActivityInfo = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/lotteryActivityList`,
    params,
  );
};

/**
 * 进行抽奖
 */
export const userPrizeDraw = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/userPrizeDraw`,
    params,
  );
};

/**
 * 走马灯列表
 */
export const trottingHorseLamp = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/trottingHorseLamp`,
    params,
  );
};

/**
 * 用户打开分享
 */
export const userShareTask = (params) => {
  return unionAxios.post(`/web-h5/charge/userShare/userShareTask`, params);
};

/**
 * 批量查询充电累计活动参与情况
 */
export const batchCumulateByUid = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingHomepage/batchCumulateByUid`,
    params,
  );
};

/**
 * 查询中奖列表
 */
export const winningRecord = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/winningRecord`,
    params,
  );
};

/**
 * 查询中奖信息
 */
export const getBenefitInfo = (params) => {
  return unionAxios.post(`/web-h5/charge/benefit/info`, params);
};

/**
 * 查询附近充电站列表
 */
export const findNearByStationV2 = (params) => {
  return unionAxios.post(
    `/web-h5/charge/station/search/findNearByStationV2`,
    params,
  );
};

/**
 * 获取指定站点列表
 * @param params 查询参数 { stationIds: string[] }
 */
export const queryStationList = (params) => {
  return unionAxios.post(
    `/web-h5/charge/station/search/queryStationList`,
    params,
  );
};
